export default {
  nav_home: 'Início',
  nav_guides: 'Guias',
  nav_shipping: 'Envio',
  nav_qc: 'QC',
  nav_warehouse: 'Warehouse',
  nav_coupon: 'Cupons',
  nav_language: 'Idioma',
  nav_about: 'Sobre',
  nav_contact: 'Contato',
  hero_title: 'CSSBuy Spreadsheet: Guias, Links e Recursos Atualizados',
  hero_subtitle: 'Explore recursos de CSSBuy Spreadsheet, QC, envio, warehouse, reviews e comparações em um só lugar.',
  hero_cta_explore: 'Explorar CSSBuy Spreadsheet',
  hero_cta_guide: 'Ver Guia para Iniciantes',
  badge_independent: 'Independente',
  badge_updated: 'Atualizado',
  badge_transparent: 'Transparente',
  categories_title: 'Categorias Populares',
  categories_select: 'Selecionar Categoria',
  categories_browse: 'Navegar por Categorias',
  what_is_title: 'O que é CSSBuy Spreadsheet',
  what_is_desc: 'CSSBuy Spreadsheet é uma ferramenta essencial para compradores que utilizam o agente CSSBuy para adquirir produtos de plataformas chinesas como Taobao, Weidian e 1688. O spreadsheet organiza links de produtos, preços, imagens de QC e status de envio em formato fácil de navegar. Nosso hub centraliza os melhores recursos de CSSBuy Spreadsheet, mantendo tudo atualizado para 2026.',
  guides_title: 'Guias em Destaque',
  review_title: 'CSSBuy Review',
  review_desc: 'Análise completa e independente do agente CSSBuy. Avaliamos QC, custos de envio, taxas de serviço, suporte ao cliente e experiência do usuário. Leia nossa review honesta antes de começar a comprar.',
  shipping_title: 'Custo de Envio CSSBuy',
  shipping_desc: 'Calcule e compare os custos de envio internacional da CSSBuy. Conheça as diferentes linhas de envio disponíveis, prazos de entrega e dicas para economizar no frete para o Brasil, EUA, Europa e outros destinos.',
  warehouse_title: 'CSSBuy Warehouse',
  warehouse_desc: 'Entenda como funciona o armazenamento no warehouse da CSSBuy. Descubra prazos de armazenamento gratuito, taxas de consolidação, serviços de embalagem e como gerenciar seu inventário de compras.',
  coupon_title: 'Cupons e Códigos de Desconto',
  coupon_desc: 'Encontre os cupons e códigos de desconto mais recentes da CSSBuy. Economize nas taxas de serviço e envio com nossas promoções atualizadas regularmente para novos e usuários existentes.',
  comparison_title: 'Comparação de Agentes',
  safety_title: 'Segurança e Confiança',
  safety_desc: 'Aprenda a comprar com segurança usando CSSBuy. Nosso guia de segurança cobre verificação de produtos, proteção de pagamento, evitando golpes e como verificar a autenticidade dos itens.',
  faq_title: 'Perguntas Frequentes',
  faq_q1: 'O que é CSSBuy Spreadsheet?',
  faq_a1: 'CSSBuy Spreadsheet é uma coleção organizada de links de produtos, preços e informações de QC para compradores que usam o agente CSSBuy. É uma ferramenta essencial para encontrar os melhores produtos de forma rápida.',
  faq_q2: 'CSSBuy é confiável?',
  faq_a2: 'Sim, CSSBuy é um agente de compras estabelecido com anos de operação. Recomendamos sempre verificar reviews recentes e usar os serviços de QC para garantir a qualidade dos produtos.',
  faq_q3: 'Como usar o CSSBuy Spreadsheet?',
  faq_a3: 'Navegue pelas categorias de produtos, clique nos links para ver detalhes, adicione itens ao seu carrinho CSSBuy e finalize a compra. O spreadsheet organiza tudo para facilitar sua experiência.',
  faq_q4: 'Quais métodos de envio a CSSBuy oferece?',
  faq_a4: 'CSSBuy oferece diversas linhas de envio incluindo EMS, DHL, EUB, SAL, e linhas específicas para diferentes regiões. Os prazos e custos variam conforme o destino e peso do pacote.',
  faq_q5: 'Como funciona o warehouse da CSSBuy?',
  faq_a5: 'O warehouse da CSSBuy recebe seus produtos dos vendedores, realiza inspeção de qualidade (QC), armazena itens por até 180 dias gratuitamente e consolida múltiplos pedidos em um único envio.',
  cta_main_title: 'Pronto para começar com CSSBuy?',
  cta_main_desc: 'Explore nossos recursos e comece a comprar com confiança.',
  cta_main_button: 'Visitar Site Principal',
  cta_main_button2: 'Explorar Spreadsheet',
  articles_title: 'Artigos e Guias',
  articles_read_more: 'Ler Artigo Completo',
  articles_view_all: 'Ver Todos os Artigos',
  footer_about: 'Sobre',
  footer_guides: 'Guias',
  footer_resources: 'Recursos',
  footer_contact: 'Contato',
  footer_policy: 'Política Editorial',
  footer_disclaimer: 'Este site é um recurso informativo independente e não é afiliado à CSSBuy.',
  footer_copyright: 'cssbuybr.wiki - Todos os direitos reservados.',
  meta_home_title: 'CSSBuy Spreadsheet 2026: Guias, Links e Recursos Atualizados',
  meta_home_desc: 'Explore recursos de CSSBuy Spreadsheet, QC, envio, warehouse, reviews e comparações. Guias atualizados para 2026.',
  article_spreadsheet_guide_title: 'Guia Completo CSSBuy Spreadsheet 2026',
  article_spreadsheet_guide_desc: 'O guia definitivo para dominar o CSSBuy Spreadsheet. Aprenda a encontrar produtos, verificar QC, comparar preços e enviar para qualquer lugar do mundo.',
  article_spreadsheet_guide_content: 'CSSBuy Spreadsheet se tornou uma das ferramentas mais procuradas por compradores internacionais que desejam adquirir produtos de plataformas chinesas como Taobao, Weidian e 1688. Este guia completo para 2026 cobre tudo que você precisa saber para aproveitar ao máximo essa ferramenta poderosa.',
  article_review_title: 'CSSBuy Review 2026: Análise Completa',
  article_review_desc: 'Review independente e honesta do agente CSSBuy. Avaliação detalhada de QC, envio, taxas e suporte.',
  article_shipping_title: 'Guia de Envio CSSBuy 2026',
  article_shipping_desc: 'Cálculo de custos, métodos de envio, prazos e dicas para economizar no frete internacional.',
  article_warehouse_title: 'Guia do Warehouse CSSBuy',
  article_warehouse_desc: 'Como funciona o armazenamento, consolidação, prazos e taxas do warehouse da CSSBuy.',
  article_qc_title: 'Guia de QC CSSBuy',
  article_qc_desc: 'Entenda como funciona o Quality Check da CSSBuy e como usar fotos de QC para verificar seus produtos.',
  article_coupon_title: 'Cupons e Códigos de Desconto CSSBuy',
  article_coupon_desc: 'Lista atualizada de cupons CSSBuy, códigos de desconto e promoções ativas para 2026.',
  back_to_home: 'Voltar para Início',
  last_updated: 'Última atualização',
  related_articles: 'Artigos Relacionados',
  table_feature: 'Recurso',
  table_cssbuy: 'CSSBuy',
  table_superbuy: 'Superbuy',
  table_sugargoo: 'Sugargoo',
  table_basetao: 'Basetao',
  table_research: 'Pesquisa',
  table_qc: 'QC',
  table_shipping: 'Envio',
  table_ease: 'Facilidade',
  table_fees: 'Taxas',
  table_bestfor: 'Melhor Para',
  nav_shopping_guide: 'Guia de Compras',
  article_discount_code_title: 'Guia de Códigos de Desconto CSSBuy 2026',
  article_discount_code_desc: 'Encontre códigos de desconto CSSBuy verificados, cupons ativos e promoções para economizar nas taxas de serviço e envio em 2026.',
  article_legit_title: 'CSSBuy é Confiável? Análise Honesta 2026',
  article_legit_desc: 'Análise detalhada e honesta sobre a confiabilidade da CSSBuy, incluindo segurança, reputação, taxas e proteção ao comprador.',
  article_shipping_cost_title: 'Guia de Custo de Envio CSSBuy 2026',
  article_shipping_cost_desc: 'Entenda quanto custa o envio internacional da CSSBuy, compare linhas e aprenda a economizar no frete para Brasil, EUA e Europa.',
  article_w2c_title: 'Guia do Spreadsheet W2C CSSBuy 2026',
  article_w2c_desc: 'O que é W2C, como usar links W2C no CSSBuy Spreadsheet e como encontrar os melhores produtos de forma segura e rápida.',
  article_beginner_title: 'Guia para Iniciantes CSSBuy 2026',
  article_beginner_desc: 'Guia completo para iniciantes aprenderem a comprar com CSSBuy do zero: cadastro, pedidos, QC, envio e dicas essenciais.',
  article_comparison_title: 'CSSBuy vs Superbuy vs Sugargoo: Comparação 2026',
  article_comparison_desc: 'Comparação detalhada entre CSSBuy, Superbuy e Sugargoo: taxas, QC, envio, facilidade de uso e qual agente escolher.',
  article_spreadsheet_links_title: 'Links e Recursos do CSSBuy Spreadsheet 2026',
  article_spreadsheet_links_desc: 'Coleção atualizada de links do CSSBuy Spreadsheet, recursos, comunidades e ferramentas para encontrar os melhores produtos.',
  article_warehouse_fees_title: 'Taxas do Warehouse CSSBuy Explicadas 2026',
  article_warehouse_fees_desc: 'Entenda todas as taxas do warehouse CSSBuy: armazenamento, consolidação, embalagem e como evitar custos extras.',
  lang_pt: 'Português',
  lang_en: 'English',
  lang_de: 'Deutsch',
};